import React from 'react';
import {
  BrowserRouter, Redirect, Switch, Route
} from "react-router-dom";
import 'antd/dist/antd.css';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { ActionCreators } from './redux/actions';

import Login from './pages/Login';
import Home from './pages/Home';
import AdminList from './pages/AdminList';
import OrderList from './pages/OrderList';
import OrderListSortByDriver from './pages/OrderListSortByDriver';
import DriverList from './pages/DriverList';
import DriverInfo from './pages/DriverInfo';
import VehicleList from './pages/VehicleList';
import TrafficNewsList from './pages/TrafficNewsList';
import ADList from './pages/ADList';
import UserTncList from './pages/UserTncList';
import DriverTncList from './pages/DriverTncList';
import FeedBackList from './pages/FeedBackList';

import PublicRoute from './PublicRoute';
import PrivateRoute from './PrivateRoute';
import NotFound from './components/NotFound';
import DriverStoreValueList from './pages/DriverStoreValueList';
class AppRoute extends React.PureComponent {
  render() {
    // console.log('Pure component AppRoute');
    return (
      <BrowserRouter>
        <Switch>
          <PublicRoute restricted path="/login" component={Login} exact />
          <PrivateRoute restricted path="/home" component={Home} privilege={'admin'} exact />
          <PrivateRoute restricted path="/admin_list" component={AdminList} privilege={'admin'} exact />
          <PrivateRoute restricted path="/order_list" component={OrderList} privilege={'admin'} exact />
          <PrivateRoute restricted path="/order_list_sort_by_driver" component={OrderListSortByDriver} privilege={'admin'} exact />
          <PrivateRoute restricted path="/driver_list" component={DriverList} privilege={'admin'} exact />
          <PrivateRoute restricted path="/driver_info" component={DriverInfo} privilege={'admin'} exact />
          <PrivateRoute restricted path="/vehicle_list" component={VehicleList} privilege={'admin'} exact />
          <PrivateRoute restricted path="/trafficnews_list" component={TrafficNewsList} privilege={'admin'} exact />
          <PrivateRoute restricted path="/ad_list" component={ADList} privilege={'admin'} exact />
          <PrivateRoute restricted path="/user_tnc_list" component={UserTncList} privilege={'admin'} exact />
          <PrivateRoute restricted path="/driver_tnc_list" component={DriverTncList} privilege={'admin'} exact />
          <PrivateRoute restricted path="/feedback_list" component={FeedBackList} privilege={'admin'} exact />
          <PrivateRoute restricted path="/driver_store_value_list" component={DriverStoreValueList} privilege={'admin'} exact />
          {/* <Route restricted path="/404" component={NotFound} exact /> */}
          <Redirect exact from="/*" to="/login" />
        </Switch>
      </BrowserRouter>
    )
  }
}

function mapStateToProps(state) {
  return { ...state };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppRoute);
